import axios from "axios";

export class CdnService {
  /** @type {AxiosInstance} */
  _axiosInstance;
  /** @type {Logger} */
  _logger;

  /**
   * Construct a service that fetches blobs from the CDN with the given base URL.
   * @param baseUrl Base URL of the CDN
   * @param logger Logger
   */
  constructor(baseUrl, logger) {
    this._axiosInstance = axios.create({
      baseURL: baseUrl,
    });
    this._logger = logger;
  }

  /**
   * Fetch the blob at the given path from the CDN.
   * @param path Blob path
   * @returns {Promise<any>} CDN blob data
   * @throws if an error occurs when fetching the blob
   */
  async getBlob(path) {
    try {
      const response = await this._axiosInstance.get(path);
      return response.data;
    } catch (error) {
      this._logger?.error?.(`Failed to get the cdn blob at ${path}: ${error.name} - ${error.message}`);
      throw error;
    }
  }
}
